// extracted by mini-css-extract-plugin
module.exports = {"logo":"HomePage_logo__3w-5p","main":"HomePage_main__BrklT"};